import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import type { ElasticVehiclesResponse } from '@//app/api/search/vehicles';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { httpClientGetJson } from '../../httpClient';
import { resolveIncludeSoldAtFrom } from '../../utils';

let hasRefetched = false;

interface UseFacets {
  initialData?: ElasticVehiclesResponse;
}

const useVehicleFacets = (settings?: UseFacets) => {
  const apiBaseUrl = useApiBaseUrl();
  const queryClient = useQueryClient();

  const params = useMemo(() => {
    const urlParams = new URLSearchParams();
    urlParams.set('hits', '0');
    urlParams.set('includeSoldAtFrom', resolveIncludeSoldAtFrom());
    urlParams.sort();
    return urlParams;
  }, []);

  const query = useQuery<ElasticVehiclesResponse>({
    queryKey: ['searchVehicleFacets'],
    queryFn: async () => {
      const url = `${apiBaseUrl}/api/search/vehicles?${params.toString()}`;
      return await httpClientGetJson<ElasticVehiclesResponse>(url);
    },
    initialData: settings?.initialData,
  });

  useEffect(() => {
    if (query.data) {
      queryClient.setQueryData(['vehicles', `?${params.toString()}`], query.data);
    }
  }, [query.data]);

  useEffect(() => {
    if (!hasRefetched) {
      query.refetch();
      hasRefetched = true;
    }
  }, []);

  return query;
};

export default useVehicleFacets;
